import { MULTITAB_LOGOUT } from "../../ActionTypes";

export const logoutMultiTab = () => (dispatch) => { 
  dispatch({ type: MULTITAB_LOGOUT });
};
